import React, { useEffect, useState } from "react";
import db from "../../firebase";
import Language from "../Language/Language";
import "./Home.css";
import image from "../../myimage2.jpeg";
import { Facebook, Instagram, LinkedIn } from "@material-ui/icons";
import LinkIcons from "../LinkIcons/LinkIcons";
import bgImage from "../../images/bg.jpg";

function Home() {
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    db.collection("languages").onSnapshot((snapshot) =>
      setLanguages(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          language: doc.data(),
        }))
      )
    );
  }, []);

  return (
    <div className="home">
      <div className="home__imageSection">
        <img className="home__image" src={bgImage} alt="" />
        <h3>Programming is an Art, Be the artist</h3>
      </div>
      <div className="home__icons">
        <LinkIcons
          Icon={Instagram}
          title="Instagram Profile"
          color="#B93082"
          link="https://www.instagram.com/yatzcool/"
        />
        <LinkIcons
          Icon={Facebook}
          title="Facebook Profile"
          color="#4064AC"
          link="https://www.facebook.com/yesh.faith"
        />
        <LinkIcons
          Icon={LinkedIn}
          title="LinkedIn Profile"
          color="#0A66C2"
          link="https://www.linkedin.com/in/yash-maurya-674030204/"
        />
      </div>
      <div className="home__avatar">
        <img src={image} alt="" />
      </div>
      <div className="home__technologies">
        <h1>Have Worked On :</h1>
        <div className="home__technologiesLanguages">
          {languages.map(({ id, language }) => (
            <Language
              key={id}
              link={language.link}
              color={language.color}
              title={language.title}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Home;
